import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.scss']
})
export class ContactusComponent implements OnInit {
  contactForm: FormGroup;
  activMap = 'Mumbai';
  corporate = true;
  mumbai = false;
  thane = false ;
  contactInfo = [
    { title: 'General Informaton', subtitle: 'Inquiry', id: 'info@arkedge.com', icon: '#icon_contact', phone: '+91 9029290808' },
    { title: 'Sales & Learning', subtitle: 'Business development', id: 'sales@arkedge.com', icon: '#icon_development' },
    { title: 'Current Openings', subtitle: 'Job apply', id: 'careers@arkedge.com', icon: '#icon_approved' }
  ];

  getTouch = [
    { img: 'assets/images/contact', subtitle: 'Corporate Office', street_1: 'Arkedge Technologies Pvt Ltd.703, Wing "B", Galaxy L.X.APT.,', street_2: 'Navre Park, Ambarnath (W), Thane - 421501', state: 'Maharashtra, India', contact: '+91 9029290808', id: 'info@arkedge.com' },
    { img: 'assets/images/contact', subtitle: 'Mumbai', street_1: 'C-1103, 11th Floor, Manavsthal Heights, Adj. Ashok Nagar,', street_2: 'Marol, Andheri (E) Mumbai 400072,', state: 'Maharashtra, India', contact: '+91 9029290808', id: 'info@arkedge.com' },
    { img: 'assets/images/contact', subtitle: 'Delhi', street_1: 'C-20, 5/F, Jasola Heights, Pocket 9A,', street_2: 'Jasola Vihar, New Delhi - 110025', state: 'Delhi, India', contact: '+91 9029290808', id: 'info@arkedge.com' },
  ];

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {
    this.contactForm = this.fb.group({
      name: ['', Validators.required ],
      email: ['', Validators.compose([Validators.required, Validators.email])],
      phone: [null, Validators.compose([Validators.required])],
      country: [null, Validators.compose([Validators.required])],
      subject: ['', Validators.required],
      message: ['', Validators.required]
   });
   }

   onSubmitContactForm() {
    if(this.contactForm.valid) {
      this.toastr.success("Your Message is Sent.");
      this.contactForm.reset();
    } else {
      this.contactForm.markAllAsTouched();
      this.toastr.error("Please fill mandatory information");
      // if(this.contactForm.get("name").invalid) {
      //   this.toastr.error("Please fill your name.")
      // } else if(this.contactForm.get("email").invalid) {
      //   if(this.contactForm.get("email").errors.required) {
      //     this.toastr.error("Please fill your email address.");
      //   } else {
      //     this.toastr.error("Email address is Invalid");;
      //   }
      // } else if(this.contactForm.get("phone").invalid) {
      //   this.toastr.error("Please fill your Phone Number.");
      // } else if(this.contactForm.get("country").invalid) {
      //   this.toastr.error("Please fill Country Information.");
      // } else if(this.contactForm.get("subject").invalid) {
      //   this.toastr.error("Please fill the subject of message.");
      // } else if(this.contactForm.get("message").invalid) {
      //   this.toastr.error("Please fill the message.");
      // }
    }
  }

  ngOnInit() {
  }

  getFormValidation(fieldName) {
    if(this.contactForm.get(fieldName).errors && this.contactForm.get(fieldName).touched) {
      if(this.contactForm.get(fieldName).errors.required) {
        return "required";
      } else  if(this.contactForm.get(fieldName).errors.email) {
        return "invalid";
      }
    }
    return false
  }

  changeMap(map) {
      if (map === 'Corporate Office') {
        this.activMap = 'Corporate Office';
        this.corporate = true;
        this.mumbai = false;
        this.thane = false;
      } else if (map === 'Mumbai') {
        this.activMap = 'Mumbai';
        this.corporate = false;
        this.mumbai = true;
        this.thane = false;
      } else if (map === 'Thane') {
        this.activMap = 'Thane';
        this.corporate = false;
        this.mumbai = false;
        this.thane = true;
      }
  }
}
